import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=15e5438f&"
import script from "./Reactions.vue?vue&type=script&lang=js&"
export * from "./Reactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports